import { toast } from 'react-toastify';
import Api from '../lib/api/api';
import { ERROR_MESSAGE } from '../lib/constants';

// get monitoring data
export const getMonitoring = (token, pagination, filter) => async dispatch => {
  const api = new Api(token);
  try {
    const data = await api.boxes.dashboardMonitoring(pagination, filter);
    dispatch({
      type: 'GET_DASHBOARD_MONITORING_SUCCESS',
      data,
    });
    return data;
  } catch (error) {
    toast.error(error?.response?.data || ERROR_MESSAGE, {
      toastId: 'GET_DASHBOARD_MONITORING',
    });
    return false;
  }
};
